import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

export type WrapperProps = HTMLAttributes<HTMLDivElement> & {
  borderColor: string;
};

const Wrapper = styled('div')<WrapperProps>(
  {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 6,
    padding: 10,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10
  },
  ({ theme, borderColor }) => ({
    backgroundColor: theme.palette.colors.white,
    borderColor
  })
);

export default Wrapper;
